function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgScene = function SvgScene(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), React.createElement("g", null, React.createElement("g", {
    transform: "translate(1 1)"
  }, React.createElement("path", {
    style: {
      fill: "#E3E7F2"
    },
    d: "M50.2,115.992v278.016C-6.689,310.067-6.689,199.933,50.2,115.992z"
  }), React.createElement("g", null, React.createElement("circle", {
    style: {
      fill: "#F0C419"
    },
    cx: 92.867,
    cy: 417.133,
    r: 17.067
  }), React.createElement("circle", {
    style: {
      fill: "#F0C419"
    },
    cx: 92.867,
    cy: 255,
    r: 17.067
  }), React.createElement("circle", {
    style: {
      fill: "#F0C419"
    },
    cx: 92.867,
    cy: 92.867,
    r: 17.067
  })), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#E3E7F2"
    },
    d: "M380.525,468.333c-77.496,45.511-173.555,45.511-251.051,0H380.525z"
  }), React.createElement("path", {
    style: {
      fill: "#E3E7F2"
    },
    d: "M129.475,41.667c77.496-45.511,173.555-45.511,251.051,0H129.475z"
  })), React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
    id: "SVGCleanerId_0",
    style: {
      fill: "#F0C419"
    },
    d: "M216.344,173.165L203.8,178.2l-9.472-23.808 c-0.853-2.103-0.828-4.461,0.07-6.546c0.898-2.085,2.594-3.723,4.709-4.548l36.352-14.507l22.357-8.875l25.173-10.069 l22.357-8.875h0.085l25.088-10.069l22.357-8.875l0.085-0.085l4.608-1.792c2.092-0.866,4.444-0.857,6.529,0.025 s3.729,2.564,4.564,4.669l9.557,23.808l-44.288,17.664l-22.443,8.96l-25.173,9.984l-22.357,8.96l-25.173,10.069L216.344,173.165 z"
  })), React.createElement("path", {
    style: {
      fill: "#F0C419"
    },
    d: "M203.8,178.2h187.733v25.6c-0.014,4.707-3.826,8.519-8.533,8.533V306.2 c-0.014,4.707-3.826,8.519-8.533,8.533h-153.6c-4.707-0.014-8.519-3.826-8.533-8.533v-93.867 c-4.707-0.014-8.519-3.826-8.533-8.533V178.2z"
  })), React.createElement("path", {
    style: {
      fill: "#E3E7F2"
    },
    d: "M502.467,255c0.104,49.576-14.767,98.027-42.667,139.008c-7.617,11.235-16.182,21.798-25.6,31.573 V84.419c9.418,9.775,17.983,20.338,25.6,31.573C487.699,156.973,502.571,205.424,502.467,255z"
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#D4E1F4"
    },
    d: "M67.267,41.667c-9.414,0.028-17.039,7.652-17.067,17.067V255h25.6 c0-9.426,7.641-17.067,17.067-17.067s17.067,7.641,17.067,17.067h25.6V41.667H67.267z M92.867,109.933 c-9.426,0-17.067-7.641-17.067-17.067S83.441,75.8,92.867,75.8s17.067,7.641,17.067,17.067 C109.906,102.281,102.281,109.906,92.867,109.933z"
  }), React.createElement("path", {
    style: {
      fill: "#D4E1F4"
    },
    d: "M109.933,255c0,9.426-7.641,17.067-17.067,17.067S75.8,264.426,75.8,255H50.2v196.267 c0.028,9.414,7.653,17.039,17.067,17.067h68.267V255H109.933z M92.867,434.2c-9.426,0-17.067-7.641-17.067-17.067 c0-9.426,7.641-17.067,17.067-17.067s17.067,7.641,17.067,17.067C109.906,426.548,102.281,434.172,92.867,434.2z"
  })), React.createElement("g", null, React.createElement("circle", {
    style: {
      fill: "#7D6599"
    },
    cx: 92.867,
    cy: 417.133,
    r: 17.067
  }), React.createElement("circle", {
    style: {
      fill: "#7D6599"
    },
    cx: 92.867,
    cy: 255,
    r: 17.067
  }), React.createElement("circle", {
    style: {
      fill: "#7D6599"
    },
    cx: 92.867,
    cy: 92.867,
    r: 17.067
  })), React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
    id: "SVGCleanerId_0_1_",
    style: {
      fill: "#A4C2F7"
    },
    d: "M216.344,173.165L203.8,178.2l-9.472-23.808 c-0.853-2.103-0.828-4.461,0.07-6.546c0.898-2.085,2.594-3.723,4.709-4.548l36.352-14.507l22.357-8.875l25.173-10.069 l22.357-8.875h0.085l25.088-10.069l22.357-8.875l0.085-0.085l4.608-1.792c2.092-0.866,4.444-0.857,6.529,0.025 s3.729,2.564,4.564,4.669l9.557,23.808l-44.288,17.664l-22.443,8.96l-25.173,9.984l-22.357,8.96l-25.173,10.069L216.344,173.165 z"
  })), React.createElement("path", {
    style: {
      fill: "#A4C2F7"
    },
    d: "M383,306.2c-0.014,4.707-3.826,8.519-8.533,8.533h-153.6c-4.707-0.014-8.519-3.826-8.533-8.533 v-93.867c-4.707-0.014-8.519-3.826-8.533-8.533v-25.6h187.733v25.6c-0.014,4.707-3.826,8.519-8.533,8.533V306.2z"
  }), React.createElement("path", {
    style: {
      fill: "#A4C2F7"
    },
    d: "M459.8,58.733v392.533c-0.028,9.414-7.652,17.039-17.067,17.067h-62.208 c19.781-11.702,37.845-26.089,53.675-42.752V84.419c-15.83-16.663-33.893-31.05-53.675-42.752h62.208 C452.148,41.694,459.773,49.319,459.8,58.733z"
  })), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#E3E7F2"
    },
    d: "M380.525,41.667H135.533v426.667h244.992c19.781-11.702,37.845-26.089,53.675-42.752V84.419 C418.37,67.756,400.307,53.368,380.525,41.667z M391.533,203.8c-0.014,4.707-3.826,8.519-8.533,8.533V306.2 c-0.014,4.707-3.826,8.519-8.533,8.533h-153.6c-4.707-0.014-8.519-3.826-8.533-8.533v-93.867 c-4.707-0.014-8.519-3.826-8.533-8.533v-25.6l-9.472-23.808c-0.853-2.103-0.828-4.461,0.07-6.546 c0.898-2.085,2.594-3.723,4.709-4.548l36.352-14.507l22.357-8.875l25.173-10.069l22.357-8.875h0.085l25.088-10.069l22.357-8.875 l0.085-0.085l4.608-1.792c2.092-0.866,4.444-0.857,6.529,0.025s3.729,2.564,4.564,4.669l9.557,23.808l-44.288,17.664 l-22.443,8.96l-25.173,9.984l-22.357,8.96l-25.173,10.069l-22.443,8.875L203.8,178.2h187.733V203.8z"
  }), React.createElement("g", null, React.createElement("path", {
    id: "SVGCleanerId_0_2_",
    style: {
      fill: "#E3E7F2"
    },
    d: "M216.344,173.165L203.8,178.2l-9.472-23.808 c-0.853-2.103-0.828-4.461,0.07-6.546c0.898-2.085,2.594-3.723,4.709-4.548l36.352-14.507l22.357-8.875l25.173-10.069 l22.357-8.875h0.085l25.088-10.069l22.357-8.875l0.085-0.085l4.608-1.792c2.092-0.866,4.444-0.857,6.529,0.025 s3.729,2.564,4.564,4.669l9.557,23.808l-44.288,17.664l-22.443,8.96l-25.173,9.984l-22.357,8.96l-25.173,10.069L216.344,173.165 z"
  })), React.createElement("path", {
    style: {
      fill: "#E3E7F2"
    },
    d: "M383,306.2c-0.014,4.707-3.826,8.519-8.533,8.533h-153.6c-4.707-0.014-8.519-3.826-8.533-8.533 v-93.867c-4.707-0.014-8.519-3.826-8.533-8.533v-25.6h187.733v25.6c-0.014,4.707-3.826,8.519-8.533,8.533V306.2z"
  }), React.createElement("path", {
    style: {
      fill: "#E3E7F2"
    },
    d: "M434.2,58.733v25.685c-15.83-16.663-33.893-31.05-53.675-42.752h36.608 C426.548,41.694,434.173,49.319,434.2,58.733z"
  }), React.createElement("path", {
    style: {
      fill: "#E3E7F2"
    },
    d: "M380.525,468.333c19.781-11.702,37.845-26.089,53.675-42.752v25.685 c-0.028,9.414-7.653,17.039-17.067,17.067H380.525z"
  })), React.createElement("g", null, React.createElement("circle", {
    style: {
      fill: "#A4C2F7"
    },
    cx: 92.867,
    cy: 92.867,
    r: 17.067
  }), React.createElement("circle", {
    style: {
      fill: "#A4C2F7"
    },
    cx: 92.867,
    cy: 255,
    r: 17.067
  }), React.createElement("circle", {
    style: {
      fill: "#A4C2F7"
    },
    cx: 92.867,
    cy: 417.133,
    r: 17.067
  }), React.createElement("path", {
    style: {
      fill: "#A4C2F7"
    },
    d: "M383,212.333V306.2c-0.014,4.707-3.826,8.519-8.533,8.533h-153.6 c-4.707-0.014-8.519-3.826-8.533-8.533v-93.867H383z"
  })), React.createElement("path", {
    style: {
      fill: "#E3E7F2"
    },
    d: "M357.4,212.333V306.2c-0.014,4.707-3.826,8.519-8.533,8.533h-128 c-4.707-0.014-8.519-3.826-8.533-8.533v-93.867H357.4z"
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#A4C2F7"
    },
    d: "M391.533,178.2v25.6c-0.014,4.707-3.826,8.519-8.533,8.533H212.333 c-4.707-0.014-8.519-3.826-8.533-8.533v-25.6H391.533z"
  }), React.createElement("path", {
    style: {
      fill: "#A4C2F7"
    },
    d: "M378.221,108.653l-44.288,17.664l-22.443,8.96l-25.173,9.984l-22.357,8.96l-25.173,10.069 l-22.443,8.875L203.8,178.2l-9.472-23.808c-0.853-2.103-0.828-4.461,0.07-6.546c0.898-2.085,2.594-3.723,4.709-4.548 l36.352-14.507l22.357-8.875l25.173-10.069l22.357-8.875h0.085l25.088-10.069l22.357-8.875l0.085-0.085l4.608-1.792 c2.092-0.866,4.444-0.857,6.529,0.025s3.729,2.564,4.564,4.669L378.221,108.653z"
  }))), React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M51.2,452.267c0.028,9.414,7.653,17.039,17.067,17.067h25.6 c-9.414-0.028-17.039-7.652-17.067-17.067v-57.259c-56.889-83.941-56.889-194.075,0-278.016V59.733 c0.028-9.414,7.652-17.039,17.067-17.067h-25.6c-9.414,0.028-17.039,7.652-17.067,17.067v57.259 c-56.889,83.941-56.889,194.075,0,278.016V452.267z"
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#428DFF"
    },
    d: "M469.333,59.733c-0.015-14.132-11.468-25.585-25.6-25.6h-60.046 c-79.042-45.511-176.332-45.511-255.374,0H68.267c-14.132,0.015-25.585,11.468-25.6,25.6v54.818 c-56.889,85.719-56.889,197.179,0,282.898v54.817c0.015,14.132,11.468,25.585,25.6,25.6h60.046 c79.042,45.511,176.332,45.511,255.374,0h60.046c14.132-0.015,25.585-11.468,25.6-25.6v-54.818 c56.889-85.719,56.889-197.178,0-282.898V59.733z M344.536,34.133H167.464C224.295,11.378,287.705,11.378,344.536,34.133z  M17.067,256c-0.03-37.357,8.74-74.196,25.6-107.532v215.064C25.807,330.196,17.036,293.357,17.067,256z M59.733,452.267V59.733 c0.005-4.711,3.822-8.529,8.533-8.533H128v409.6H68.267C63.556,460.795,59.738,456.978,59.733,452.267z M256,494.933 c-30.327-0.029-60.372-5.82-88.536-17.067h177.072C316.372,489.113,286.327,494.905,256,494.933z M452.267,452.267 c-0.005,4.711-3.822,8.529-8.533,8.533H145.067V51.2h298.667c4.711,0.005,8.529,3.822,8.533,8.533V452.267z M494.933,256 c0.03,37.357-8.74,74.196-25.6,107.532V148.468C486.194,181.804,494.964,218.643,494.933,256z"
  }), React.createElement("path", {
    style: {
      fill: "#428DFF"
    },
    d: "M93.867,119.467c14.138,0,25.6-11.462,25.6-25.6s-11.462-25.6-25.6-25.6s-25.6,11.462-25.6,25.6 C68.282,107.999,79.735,119.451,93.867,119.467z M93.867,85.333c4.713,0,8.533,3.821,8.533,8.533c0,4.713-3.821,8.533-8.533,8.533 c-4.713,0-8.533-3.821-8.533-8.533C85.338,89.156,89.156,85.338,93.867,85.333z"
  }), React.createElement("path", {
    style: {
      fill: "#428DFF"
    },
    d: "M93.867,230.4c-14.138,0-25.6,11.462-25.6,25.6c0,14.139,11.462,25.6,25.6,25.6 s25.6-11.461,25.6-25.6C119.451,241.868,107.999,230.415,93.867,230.4z M93.867,264.533c-4.713,0-8.533-3.821-8.533-8.533 c0-4.713,3.821-8.533,8.533-8.533c4.713,0,8.533,3.821,8.533,8.533C102.395,260.711,98.578,264.529,93.867,264.533z"
  }), React.createElement("path", {
    style: {
      fill: "#428DFF"
    },
    d: "M93.867,392.533c-14.138,0-25.6,11.462-25.6,25.6c0,14.138,11.462,25.6,25.6,25.6 s25.6-11.462,25.6-25.6C119.451,404.001,107.999,392.549,93.867,392.533z M93.867,426.667c-4.713,0-8.533-3.82-8.533-8.533 s3.821-8.533,8.533-8.533c4.713,0,8.533,3.821,8.533,8.533C102.395,422.844,98.578,426.662,93.867,426.667z"
  }), React.createElement("path", {
    style: {
      fill: "#428DFF"
    },
    d: "M196.267,180.837V204.8c0.02,6.069,3.272,11.668,8.533,14.692v96.241 c-0.001,2.263,0.898,4.434,2.499,6.035s3.771,2.499,6.035,2.499H384c2.263,0.001,4.434-0.898,6.035-2.499 c1.6-1.6,2.499-3.771,2.499-6.035v-96.241c5.262-3.024,8.514-8.623,8.533-14.692v-25.6c0.001-2.263-0.898-4.434-2.499-6.035 c-1.6-1.6-3.771-2.499-6.035-2.499H249.234l133.107-53.075c2.104-0.836,3.789-2.475,4.684-4.555 c0.894-2.08,0.924-4.43,0.083-6.533l-9.483-23.783c-3.509-8.738-13.422-12.996-22.175-9.525l-158.533,63.212 c-8.741,3.507-12.999,13.422-9.525,22.175L196.267,180.837z M295.133,187.733L278.067,204.8H251l17.067-17.067H295.133z  M346.333,187.733L329.267,204.8H302.2l17.067-17.067H346.333z M226.867,204.8h-13.533v-17.067h30.6L226.867,204.8z  M375.467,307.2h-153.6v-85.333h153.6V307.2z M384.009,204.8H353.4l17.067-17.067H384L384.009,204.8z M279.224,121.964 l-9.528,22.172l-25.135,10.023l9.53-22.174L279.224,121.964z M326.781,103.002l-9.527,22.17l-25.136,10.023l9.527-22.171 L326.781,103.002z M361.775,89.05l6.317,15.85l-28.415,11.33l9.527-22.167L361.775,89.05z M231.667,140.925l-9.53,22.175 l-12.57,5.012l-6.325-15.854L231.667,140.925z"
  }), React.createElement("path", {
    style: {
      fill: "#428DFF"
    },
    d: "M247.467,358.4c-4.713,0-8.533,3.82-8.533,8.533s3.821,8.533,8.533,8.533h102.4 c4.713,0,8.533-3.82,8.533-8.533s-3.82-8.533-8.533-8.533H247.467z"
  }), React.createElement("path", {
    style: {
      fill: "#428DFF"
    },
    d: "M409.6,392.533H187.733c-4.713,0-8.533,3.82-8.533,8.533s3.821,8.533,8.533,8.533H409.6 c4.713,0,8.533-3.82,8.533-8.533S414.313,392.533,409.6,392.533z"
  }))), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgScene, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/scene.f1ee49e5.svg";
export { ForwardRef as ReactComponent };